import getUse from './get-use';
import cloneProduct from './clone';
import updateProduct from './update';
import {
  genericCreate,
  genericFind,
  genericGet,
  genericRemove,
} from '@/services/common';

export const clone = cloneProduct;

export const create = genericCreate('product');

export const find = genericFind('product');

export const get = genericGet('product');

export const remove = genericRemove('product');

export const update = updateProduct;

export * from './types';

export default {
  clone,
  create,
  find,
  get,
  getUse,
  remove,
  update,
};
